export const get_tempalte_select_city_array = (data) => {
    return data.map((i) => `<li class="dropdown__list-item js-dropdown-list-item" data-value='${i.id}'>${i.city}</li>`)
}
export const get_tempalte_select_option = (data) => {
    return `<li class="dropdown__list-item js-dropdown-list-item" data-value='${data.id}'>${data.title}</li>`
}
